(() => {
  if (window.aizoneTagFiltersReady) return;
  window.aizoneTagFiltersReady = true;
  const updateLink = (link) => {
    if (link.hasAttribute('data-aiz-vendor-value')) {
      // Facets can update the URL without rerendering this section. Always
      // derive the toggle from current location, never from a rewritten href.
      const destination = new URL(window.location.href);
      const key = 'filter.p.vendor';
      const vendor = link.getAttribute('data-aiz-vendor-value');
      const selected = destination.searchParams.getAll(key);
      destination.searchParams.delete(key);
      const next = selected.includes(vendor)
        ? selected.filter((value) => value !== vendor)
        : [...selected, vendor];
      for (const value of next) destination.searchParams.append(key, value);
      destination.searchParams.delete('page');
      link.href = destination.pathname + destination.search + destination.hash;
      return;
    }
    const destination = new URL(link.getAttribute('href'), window.location.origin);
    if (destination.origin !== window.location.origin) return;
    const current = new URLSearchParams(window.location.search);
    destination.search = '';
    for (const [key, value] of current) {
      if (key === 'sort_by' || key.startsWith('filter.')) destination.searchParams.append(key, value);
    }
    link.href = destination.pathname + destination.search + destination.hash;
  };
  const updateLinks = () => document.querySelectorAll('[data-aiz-tag-filters] a[href]').forEach(updateLink);
  updateLinks();
  document.addEventListener('shopify:section:load', updateLinks);
  window.addEventListener('popstate', updateLinks);
  ['click', 'auxclick', 'contextmenu', 'pointerdown', 'focusin'].forEach((type) => {
    document.addEventListener(type, (event) => {
      const link = event.target.closest?.('[data-aiz-tag-filters] a[href]');
      if (link) updateLink(link);
    }, true);
  });
})();
